.niu-niu-round-details {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
}

.niu-niu-round-details h3 {
  text-align: center;
  margin: 0 0 20px 0;
  font-size: 24px;
  color: #355980;
}

.niu-niu-round-details h4 {
  margin: 15px 0 10px 0;
  font-size: 18px;
  color: #355980;
}

.round-info {
  background: #f5f5f5;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #ddd;
}

.info-row:last-child {
  border-bottom: none;
}

.info-row .label {
  font-weight: 600;
  color: #555;
}

.info-row .value {
  font-weight: 500;
  color: #333;
}

.info-row .value.correct {
  color: #2ecc71;
  font-weight: 700;
}

.info-row .value.incorrect {
  color: #e74c3c;
  font-weight: 700;
}

.cards-section {
  margin-bottom: 20px;
}

.cards-container {
  display: flex;
  gap: 10px;
  justify-content: center;
  background: #f9f9f9;
  border-radius: 8px;
}

.card-image {
  width: 100%;
  height: auto;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.niu-niu-round-details .card-image {
  width: 19%;
}

.niu-niu-round-details .cards-container {
  width: 100%;
}

.hand-result {
  background: #e8f4f8;
  border-radius: 8px;
  padding: 15px;
}

/* Winner mode styles */
.hands-section {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.hand-container {
  border: 2px solid #ddd;
  border-radius: 8px;
  padding: 15px;
  background: #fff;
  transition: all 0.3s ease;
}

.hand-container.winning-hand {
  border-color: #2ecc71;
  background: #f0fff4;
}

.hand-container.selected-hand {
  border-color: #3498db;
  background: #f0f8ff;
}

.hand-container.winning-hand.selected-hand {
  border-color: #2ecc71;
  background: #e8f8f0;
}

.hand-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.hand-number {
  font-weight: 700;
  font-size: 16px;
  color: #355980;
}

.badge {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.badge.winning {
  background: #2ecc71;
  color: #fff;
}

.badge.selected {
  background: #3498db;
  color: #fff;
}

.badge.correct {
  background: #27ae60;
  color: #fff;
}

.hand-info {
  display: flex;
  justify-content: space-around;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #eee;
  font-size: 14px;
  color: #555;
  font-weight: 500;
}

.error {
  text-align: center;
  color: #e74c3c;
  padding: 40px;
  font-size: 18px;
}

/* Mobile responsive */
@media (max-width: 600px) {
  .cards-container {
    gap: 5px;
  }

  .hand-info {
    flex-direction: column;
    gap: 5px;
    align-items: center;
  }

  .niu-niu-round-details h3 {
    font-size: 20px;
  }

  .niu-niu-round-details h4 {
    font-size: 16px;
  }
}
